import CityPageTemplate from "../city-template/CityPageTemplate";
import { codyConfig } from "./data";

export default function CodyPage() {
  return <CityPageTemplate config={codyConfig} />;
}